export default __webpack_public_path__ + "static/media/hands.bb71a7c7.jpg";